module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-23-e15e0f785cb1b92c22b4b35004f1ffb4.png";